import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(): void {
    const html = document.documentElement
    const current = html.classList.contains("dark") ? "dark" : "light"
    const next = current === "dark" ? "light" : "dark"
    html.classList.remove(current)
    html.classList.add(next)
    localStorage.setItem("nimbus:theme", next)
  }

  connect(): void {
    const saved = localStorage.getItem("nimbus:theme")
    if (saved) {
      document.documentElement.classList.add(saved)
    } else {
      document.documentElement.classList.add("dark")
    }
  }
}
